const readEnv = (value: string | boolean | undefined, fallback = '') => {
  if (typeof value === 'boolean') return value ? 'true' : 'false'
  const normalized = String(value || '').trim()
  return normalized || fallback
}

export const envConfig = {
  apiV1BaseUrl: readEnv(import.meta.env.VITE_API_V1_BASE_URL, '/api/v1'),
  posthogKey: readEnv(import.meta.env.VITE_POSTHOG_KEY),
  posthogHost: readEnv(import.meta.env.VITE_POSTHOG_HOST, 'https://us.i.posthog.com'),
  posthogUiHost: readEnv(import.meta.env.VITE_POSTHOG_UI_HOST, 'https://us.posthog.com'),
  langfusePublicKey: readEnv(import.meta.env.VITE_LANGFUSE_PUBLIC_KEY),
  langfuseBaseUrl: readEnv(import.meta.env.VITE_LANGFUSE_BASE_URL),
  logtoEndpoint: readEnv(import.meta.env.VITE_LOGTO_ENDPOINT),
  logtoAppId: readEnv(import.meta.env.VITE_LOGTO_APP_ID),
  logtoRedirectUri: readEnv(import.meta.env.VITE_LOGTO_REDIRECT_URI),
  logtoResourceApi: readEnv(import.meta.env.VITE_LOGTO_RESOURCE_API),
  logtoCallbackUri: readEnv(import.meta.env.VITE_LOGTO_CALLBACK_URI),
  logtoConnectorIds: {
    google: readEnv(import.meta.env.VITE_LOGTO_CONNECTOR_ID_GOOGLE),
    feishu: readEnv(import.meta.env.VITE_LOGTO_CONNECTOR_ID_FEISHU),
    facebook: readEnv(import.meta.env.VITE_LOGTO_CONNECTOR_ID_FACEBOOK),
    linkedin: readEnv(import.meta.env.VITE_LOGTO_CONNECTOR_ID_LINKEDIN),
  },
} as const
